module.exports = __webpack_public_path__ + "img/demo-02-slide1.0dcab342.jpg";